// Domain utama tempat aplikasi ini jalan, dipakai untuk preview "slug.domain"
// di form Cabang. Ikut domain asli (localhost saat dev, domain produksi saat live).
export const getRootDomain = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname.endsWith('.localhost')) return 'localhost';
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return hostname; // akses via IP

  const parts = hostname.split('.');
  return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
};

// Domain utama (juragankuliner.com) hanya menampilkan landing; masuk & aplikasi ada di app.<domain>.
// Mengembalikan alamat app (mis. "https://app.juragankuliner.com") bila halaman ini dibuka di luar app./kasir.,
// atau '' bila sudah di app/kasir, localhost, atau akses via IP (tidak perlu pindah host).
export const alamatAplikasiDari = (hostname, protocol = 'https:') => {
  const host = String(hostname || '').toLowerCase();
  if (!host || host === 'localhost' || host.endsWith('.localhost') || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return '';
  const parts = host.split('.');
  if (parts.length > 2 && ['app', 'kasir'].includes(parts[0])) return '';
  return `${protocol}//app.${parts.slice(-2).join('.')}`;
};

// Kebalikannya: di app./kasir.<domain>, alamat halaman utama (landing) = https://<domain>. Dipakai setelah logout / sesi habis
// supaya pengguna kembali ke landing di domain utama, bukan ke halaman di app. Kosong bila sudah di domain utama,
// localhost, atau akses via IP.
export const alamatUtamaDari = (hostname, protocol = 'https:') => {
  const host = String(hostname || '').toLowerCase();
  if (!host || host === 'localhost' || host.endsWith('.localhost') || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return '';
  const parts = host.split('.');
  if (parts.length > 2 && ['app', 'kasir'].includes(parts[0])) return `${protocol}//${parts.slice(-2).join('.')}`;
  return '';
};

export const alamatUtama = () => alamatUtamaDari(window.location.hostname, window.location.protocol);

export const alamatAplikasi = () => alamatAplikasiDari(window.location.hostname, window.location.protocol);
